import './about.component.less'

import moment from 'moment'

class AboutController {
  constructor (ClientService) {
    'ngInject'

    this.about = ClientService.about
    this.version = ClientService.version
    this.currentDateTime = moment().format()
  }
}

export default {
  controller: AboutController,
  template: require('./about.component.html').default
}
